import { IReviewDocument } from 'common/request/interfaces/reviewDocument';
import { DocumentTypeEnum } from '../../common/document/enums/document-type.enum';
import { IDocument } from '../../common/document/interfaces/document';
import { DocumentRejectionReasonEnum } from '../../common/document/enums/document-rejection-reason.enum';
import { TwilioError } from '../../integrations/twilio/error/types';

export enum ETwilioCallbackSmsStatus {
  queued = 'queued',
  sent = 'sent',
  delivered = 'delivered',
  undelivered = 'undelivered',
  failed = 'failed',
}

export type IRequest = {
  id: string;
  ticketId: string;
  status: string;
  candidateFullName: string;
  documentGroupName: string;
  documentsRequestedCount: number;
  submitedDocumentsCount: number;
  createdAt: Date;
  requestedByUserFullName: string;

  candidateCode: string;
};

export type getRequestListReadyToReviewQuery = {
  response: {
    documents: IReviewDocument[];
    totalRows: number;
  };
  request: {
    query?: string;
  };
};

export type requestMutation = {
  response: IRequest;
  request: {
    data: {
      candidateFirstName: string;
      candidateLastName: string;
      candidateEmail?: string;
      candidateEmployeeId?: string;
      candidatePhone: string;
      documentGroupName?: string;
      documentsNeeded: DocumentTypeEnum[];
    };
  };
};

export type changeDocumentTypeMutation = {
  response: { success: boolean };
  request: {
    documentId: string;
    documentType: DocumentTypeEnum;
  };
};

export type sendDriverRequestSmsMutation = {
  response: IRequest | TwilioError;
  request: {
    documentRequestId: string;
    data: {
      text: string;
    };
  };
};

export type sendDriverRequestSmsToNewNumberMutation = {
  response: IRequest;
  request: {
    documentRequestId: string;
    data: {
      number: string;
      text: string;
    };
  };
};

export type getDocumentsToReviewQuery = {
  response: {
    id: string;
    candidateFullName: string;
    candidateCode: string;
    candidatePhone: string;
    candidateId: string;
    employeeId?: string;
    status: string;
    documents: IDocument[];
  };
  request: {
    documentRequestId: string;
  };
};

export type approveDocumentRequestMutation = {
  response: IRequest;
  request: {
    documentRequestId: string;
    candidateDocumentId: string;
    details: object;
  };
};

export type rejectDocumentRequestMutation = {
  response: IRequest;
  request: {
    documentRequestId: string;
    candidateDocumentId: string;
    rejectionReason: DocumentRejectionReasonEnum;
    rejectionDetails: string;
    removeDocumentFromRequest?: boolean;
  };
};

export type purgeDocumentRequestMutation = {
  response: IRequest;
  request: {
    documentRequestId: string;
    candidateDocumentId: string;
  };
};

export type updateDocumentDetailsDocumentDotMedicalMutation = {
  response: IRequest;
  request: {
    candidateDocumentId: string;
    details: object;
  };
};

export type updateDocumentFileMutation = {
  response: any;
  request: {
    candidateDocumentId: string;
    fileName: string;
    file: File;
  };
};

export type markDriverLicenseAsWithoutPhotoMutation = {
  response: {
    success: boolean;
  };
  request: {
    candidateDocumentId: string;
    containsUserPhoto: boolean;
  };
};

export type SaveDocumentDetailsRequest = {
  confirmPost: boolean;
  candidateDocumentId: string;
  form: any;
};

export type SaveDocumentDetailsResponse = any;
